import React, { useMemo, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Loader from './components/Loader';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { auth, toast, restaurantId } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const isSuperAdmin = auth?.user?.is_super_admin === 1

  useEffect(() => {
    if (restaurantId == null) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [restaurantId]);

  const userPermissions = useMemo(() => {
    if (!auth?.user?.permissions || !restaurantId) return [];

    const restaurantPermission = auth.user.permissions.find(
      (restaurant) => restaurant.restaurant_id === restaurantId
    );

    return restaurantPermission?.permissions?.map((p) => p.module) || [];
  }, [auth?.user?.permissions, restaurantId]);

  const hasPermission = isSuperAdmin || userPermissions.includes(requiredPermission);

  // useEffect(() => {
  //   if (!hasPermission && auth?.user && restaurantId) {
  //     setTimeout(() => {
  //       toast.current.show({
  //         severity: 'error',
  //         summary: 'Access Denied',
  //         detail: 'Access denied: insufficient permissions.',
  //         life: 3000,
  //       });
  //     }, 100);
  //   }
  // }, [hasPermission, auth?.user, restaurantId]);

  if (isLoading) {
    return <Loader />;
  }

  if (hasPermission) {
    return children;
  }

  return <Navigate to={auth?.user ? '/admin/dashboard/view' : '/'} />;
};

export default ProtectedRoute;
